// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u7utZ","tabsBox":"styles_tabsBox__1tCj0","createButton":"styles_createButton__3pNJq"};